export default __webpack_public_path__ + "static/media/staff.1fae70cd.PNG";